import React, { createContext, useState } from 'react';

interface MapContextValue {
  mapIsShowed: boolean;
  setMapIsShowed: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MapContext = createContext<MapContextValue>({} as MapContextValue);

export const MapProvider: React.FC = ({ children }) => {
  const [mapIsShowed, setMapIsShowed] = useState(true);

  return <MapContext.Provider value={{ mapIsShowed, setMapIsShowed }}>{children}</MapContext.Provider>;
};
